import cx from 'classnames'
import Styles from './Divider.module.scss'

interface Props {
  noMargin?: boolean
  className?: string
  disabled?: boolean
}

const Divider = ({ noMargin = false, disabled, className }: Props) => (
  <hr className={cx(Styles.divider, { [Styles.noMargin]: noMargin, [Styles.disabled]: disabled }, className)} />
)

export { Divider }
